import { Box, Stack, Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { COLORS } from '@/styles/tokens/colors';
import { WithClasses } from '@/styles/types';

const useStyles = makeStyles()((_theme) => ({
  root: {},
  headingWrapper: {},
  headingText: {},
  actionsWrapper: {
    minHeight: '36px', // make it so the actions wrapped is roughly the size of a button so the sizing of the layout is consistent when there are no actions
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
  },
  childrenWrapper: {},
}));

export interface SubpageLayoutProps {
  heading?: React.ReactNode;
  description?: string;
  /** @default 'title-xl' */
  headingVariant?: TypographyProps['variant'];
  actions?: React.ReactNode;
  classes?: WithClasses<typeof useStyles>;
  headingSpacing?: number;
}

export function SubpageLayout({
  heading,
  description,
  headingVariant = 'title-xl',
  actions,
  children,
  headingSpacing = 2,
  ...props
}: React.PropsWithChildren<SubpageLayoutProps>) {
  const { classes } = useStyles(undefined, { props });
  const title = (
    <Typography
      variant={headingVariant}
      component="h2"
      className={classes.headingText}
    >
      {heading}
    </Typography>
  );
  return (
    <Stack spacing={headingSpacing} height="100%" className={classes.root}>
      {(heading || actions) && (
        <Stack
          direction="row"
          alignItems={description ? 'flex-start' : 'center'}
          justifyContent="space-between"
          className={classes.headingWrapper}
        >
          {description ? (
            <Stack spacing={1}>
              {title}
              <Typography
                variant="body-s"
                sx={{ color: COLORS.TEXT.SECONDARY }}
              >
                {description}
              </Typography>
            </Stack>
          ) : (
            title
          )}
          <Box className={classes.actionsWrapper}>{actions && actions}</Box>
        </Stack>
      )}
      <Stack className={classes.childrenWrapper}>{children}</Stack>
    </Stack>
  );
}
